import { Dispatch, SetStateAction, useEffect, useState } from "react";
import EstablishmentInterfaceForm from "./EstablishmentInterfaceForm";
import { Alert } from "reactstrap";


const EstablishmentInterfaceCreate = ({
  nextButtonFunction,
  setIsEstablishmentInterfaceInit,
  updateInterfaceData,
  closeWizard
}: EstablishmentInterfaceCreateProps) => {

  const initialValues: IEstablishmentInterfaceIDForm = {
    interfaceID: ""
  }
  const [submitting, setSubmitting] = useState(false);
  const [modalClosed, setModalClosed] = useState(false);

  useEffect(() => {
    if (modalClosed) {
      closeWizard();
    }
  }, [modalClosed, closeWizard]);

  const handleSubmit = (values: IEstablishmentInterfaceIDForm) => {
    setSubmitting(true);
    updateInterfaceData(values);
    setIsEstablishmentInterfaceInit(true);
    setModalClosed(true);
  };
  
  return (
  <>
   <Alert color="danger">
    Interfaces Get By Entitity's Node is not implemented
  </Alert>
    <EstablishmentInterfaceForm 
      type={"create"} 
      initialValues={initialValues} 
      onSubmit={handleSubmit}    
    />
  </>
  )
}

export default EstablishmentInterfaceCreate;

type EstablishmentInterfaceCreateProps = {
  nextButtonFunction: () => void;
  setIsEstablishmentInterfaceInit: Dispatch<SetStateAction<boolean>>;
  updateInterfaceData: (data: Partial<IEstablishmentInterfaceForm>) => void;
  closeWizard: () => void;
}